import {
  CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_BEGIN,
  CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_SUCCESS,
  CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_FAILURE,
  CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { toast } from 'react-toastify';

export function addCustomFunction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/custom-function`,
        args.payload,
        header,
      );

      doRequest.then(
        (res) => {
          if (res.status === 200 || res.status === 201) {
            dispatch({
              type: CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_SUCCESS,
              data: res.data,
            });
            toast.success('Function Added Successfully');
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddCustomFunctionError() {
  return {
    type: CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_BEGIN:
      return {
        ...state,
        addCustomFunctionPending: true,
        addCustomFunctionError: null,
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_SUCCESS:
      return {
        ...state,
        addCustomFunctionPending: false,
        addCustomFunctionError: null,
        customFunctions: [...(state.customFunctions || []), action.data],
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_FAILURE:
      return {
        ...state,
        addCustomFunctionPending: false,
        addCustomFunctionError: action.data.error,
      };

    case CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_DISMISS_ERROR:
      return {
        ...state,
        addCustomFunctionError: null,
      };

    default:
      return state;
  }
}
